const materialSelectRouter = [
  {
    path: 'material-menu',
    name: 'MaterialMenu',
    component: () => import('@/views/wxapp/designer-manager/material-select/material-menu/index.vue'),
    meta: {
      title: '选材列表'
    }
  },
  {
    path: 'material-cart',
    name: 'MaterialCart',
    component: () => import('@/views/wxapp/designer-manager/material-select/material-cart/index.vue'),
    meta: {
      title: '选材列表'
    }
  }
]
export default materialSelectRouter
